import { render, staticRenderFns } from "./DialogCreateAppointment.vue?vue&type=template&id=71541820&scoped=true"
import script from "./DialogCreateAppointment.vue?vue&type=script&lang=js"
export * from "./DialogCreateAppointment.vue?vue&type=script&lang=js"
import style0 from "./DialogCreateAppointment.vue?vue&type=style&index=0&id=71541820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71541820",
  null
  
)

export default component.exports